export default "__VITE_ASSET__B0rpK$lg__"